import { Radio as RadioAntd, RadioProps } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { COLORS, FONTS, STYLES } from 'utils/constants/styles';

interface IProps extends RadioProps {}

const StyledRadio = styled(RadioAntd)<IProps>`
    display: flex;
    align-items: center;
    gap: ${STYLES.RADIO.GAP};
    white-space: pre-line;
    margin: 5px 0px;

    &,
    span {
        font-size: ${FONTS.DESCRIPTION_FONT_SIZE};
        line-height: ${FONTS.DESCRIPTION_FONT_SIZE};
        font-weight: ${FONTS.MEDIUM};
        white-space: pre-line;
    }

    .ant-radio-inner {
        width: ${STYLES.RADIO.DIMENSION};
        height: ${STYLES.RADIO.DIMENSION};
        border-width: ${STYLES.RADIO.BORDER_WIDTH};
    }

    .ant-radio-inner::after {
        width: ${STYLES.RADIO.CHECK_DIMENSION};
        height: ${STYLES.RADIO.CHECK_DIMENSION};
        top: ${STYLES.RADIO.CHECK_POSITION};
        left: ${STYLES.RADIO.CHECK_POSITION};
    }

    &,
    &:hover,
    &:active,
    &:focus {
        color: ${props => props.theme.background.pink || COLORS.PINK};
        outline: none;
        font-weight: normal;

        .ant-radio-checked .ant-radio-inner {
            border-color: ${props => props.theme.background.pink || COLORS.PINK};
        }

        .ant-radio-inner {
            background-color: ${props => props.theme.background.white || COLORS.PINK};
            border-color: ${props => props.theme.background.pink};
        }

        .ant-radio-inner::after {
            background-color: ${props => props.theme.background.pink || COLORS.PINK};
            width: 33px;
            height: 33px;
        }
    }

    @media screen and (max-width: 992px) {
        margin: 10px 0px;
        width: 100%;
    }
`;

const CustomRadio: React.FC<IProps> = props => <StyledRadio {...props} />;

export default CustomRadio;
